exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " .WishListIcon-iconContainer-365H5 {\n     position: absolute;\n     right: 10px;\n     top: 22px;\n     z-index: 10;\n     cursor: pointer;\n }\n\n .WishListIcon-displayFlex-3BDVB {\n     display: -webkit-box;\n     display: -ms-flexbox;\n     display: flex;\n     -webkit-box-align: center;\n         -ms-flex-align: center;\n             align-items: center;\n }\n\n .WishListIcon-marginRight-1EoJ7 {\n     margin-right: 30px;\n }\n\n .WishListIcon-minWidth-2viqZ {\n     min-width: 91px;\n }", ""]);

// exports
exports.locals = {
	"iconContainer": "WishListIcon-iconContainer-365H5",
	"displayFlex": "WishListIcon-displayFlex-3BDVB",
	"marginRight": "WishListIcon-marginRight-1EoJ7",
	"minWidth": "WishListIcon-minWidth-2viqZ"
};